import { useContext } from 'react';
import UploadCardContext from '../../context/UploadCardContext';

function useUploadCardData() {
  const uploadCardData = useContext(UploadCardContext);

  return uploadCardData;
}

export default useUploadCardData;
